import { Directive, Injectable, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormsService } from '@shared/components/forms/services';
import { Field, IFieldConfig } from '@shared/models';
import { FORM_COMPONENT_TOKEN, IFormComponent } from './form-component.interface';

@Directive()
@Injectable()
export abstract class FieldBaseComponent implements Field {

  public config: IFieldConfig | undefined;
  public formService = inject(FormsService);
  public fc = inject<IFormComponent>(FORM_COMPONENT_TOKEN);

  public get formGroup(): UntypedFormGroup | undefined {
    return this.fc.form;
  }

  public get formModel(): unknown {
    return this.fc.model;
  }

  public showAsterisk(config: IFieldConfig): boolean {
    return this.formService.showIndicator(config);
  }

  public get valid(): boolean {
    if (!this.config) {
      return false;
    }

    const control = this.fc.controls?.[this.config?.name];
    return !!control && control.valid && (control.touched || this.fc.submitted);
  }

  public get invalid(): boolean {
    if (!this.config) {
      return true;
    }

    const control = this.fc.controls?.[this.config?.name];
    return !!control && control.invalid && (control.touched || this.fc.submitted);
  }
}
